import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { LanguageBootstrapService } from '@core/services/language/language-bootstrap.service';

export const languageBootstrapGuard: CanActivateFn = () => {
  const bootstrapService = inject(LanguageBootstrapService);
  return bootstrapService.ensureLoaded().pipe(map(() => true));
};

